export default "__VITE_ASSET__CWu1srok__"